interface NamedLecturer {
    firstName: string;
    lastName: string;
}

const HEBREW_START = /^\s*[֐-׿]/;
const isHebrew = (s: string) => HEBREW_START.test(s);

function compareNames(a: string, b: string): number {
    const aHe = isHebrew(a);
    const bHe = isHebrew(b);
    if(aHe !== bHe) return aHe ? -1 : 1;
    return a.localeCompare(b, aHe ? 'he' : 'en', {sensitivity: 'base'});
}

const primaryName = (l: NamedLecturer) => l.lastName || l.firstName;
const secondaryName = (l: NamedLecturer) => l.lastName ? l.firstName : '';

export function compareLecturerName<T extends NamedLecturer>(a: T, b: T): number {
    return compareNames(primaryName(a), primaryName(b)) || compareNames(secondaryName(a), secondaryName(b));
}

export function sortLecturers<T extends NamedLecturer>(lecturers: readonly T[]): T[] {
    return [...lecturers].sort(compareLecturerName);
}
